/*=========================================================================================
  File Name: moduleCourseActions.js
  Description: Course Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/Course/AddCourse", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAllCourses({ commit }) {

    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetAllCourses")
        .then((response) => {
          commit('SET_Courses', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchDataListItems({ commit }) {

    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetAll")
        .then((response) => {
          commit('SET_Courses', response.data)
          debugger
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getAllModules({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseModule/GetAll")
        .then((response) => {
          commit('SET_AllModules', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },



  fetchDataListItemsByFilter({ commit }, search) {

    return new Promise((resolve, reject) => {
      axios.post("api/Course/GetAllByFilter", search)
        .then((response) => {
          commit('SET_Courses', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetCourseModulesByCourseID({ commit }, courseID) {

    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetCourseModulesByCourseID?courseID=" + courseID)
        .then((response) => {
          commit('SET_CourseModule', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  GetCourseTypesByCourseID({ commit }, courseID) {

    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetCourseTypesByCourseID?courseID=" + courseID)
        .then((response) => {
          commit('SET_CourseTypes', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetLangaugesByCourseID({ commit }, courseID) {

    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetLangaugesByCourseID?courseID=" + courseID)
        .then((response) => {
          commit('SET_CourseLanguages', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  GetInstructorByCourseID({ commit }, courseID) {

    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetInstructorByCourseID?courseID=" + courseID)
        .then((response) => {
          commit('SET_CourseInstructor', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetCourseModuleMaterialsByCourseID({ commit }, courseID) {
    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetCourseModuleMaterialsByCourseID?courseID=" + courseID)
        .then((response) => {

          commit('SET_Material', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetCourseMaterialsByCourseID({ commit }, courseID) {
    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetAllCourseMaterialsByCourseID?courseID=" + courseID)
        .then((response) => {

          commit('SET_Material', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem(context, item) {

    return new Promise((resolve, reject) => {
      axios.put("api/Course/UpdateCourse?ID=" + item.ID, item)
        .then((response) => {
          // commit('UPDATE_Course', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetItemByID(context, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetCourse?ID=" + itemid)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Course/DeleteCourse?ID=" + item.ID)
        .then((response) => {
          debugger
          if (response.data != "" &&response.data != undefined)
          {
            debugger
            commit('REMOVE_ITEM', item.ID)
            resolve(response)
          }
          else
          {
            debugger
            resolve(response)
          }

        })
        .catch((error) => {
          debugger
          reject(error)
        })
    })
  },

  removeCourseFacility(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Course/DeleteCourseFacility?ID=" + item.ID)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeCourseEvaluationMean(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Course/DeleteCourseEvaluationMeans?ID=" + item.ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getEvaluationMeansByCourseID({ commit }, courseID) {
    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetEvaluationMeansByCourseID?courseID=" + courseID)
        .then((response) => {

          commit('SET_CourseEvaluationMean', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeCourseModule(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Course/DeleteCourseModule?ID=" + item.ID)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeCourseModuleMaterial(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Course/DeleteCourseModuleMaterial?ID=" + item.ID)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeCourseMaterial(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Course/DeleteCourseMaterial?ID=" + item.ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

}
